import { environment } from '../../../environment/env';
import { getAppConfig } from '../config/app-config';
import { APP_CONSTANTS } from '../config/app-constants';

const getAccessToken = async () => {
  // 1. Use session token from ACC.config if present
  // if (typeof ACC !== 'undefined' && ACC.config && ACC.config.sessionAuthToken) {
  //   return ACC.config.sessionAuthToken;
  // }

  // 2. Check if access token exists in sessionStorage
  let ACCESS_TOKEN = sessionStorage.getItem('accessToken');

  // 3. If token missing or expired, get guest token function to call the token api
  if (!ACCESS_TOKEN || new Date().getTime() > JSON.parse(ACCESS_TOKEN)?.expiryTime) {
    await getGuestToken();
    ACCESS_TOKEN = sessionStorage.getItem('accessToken');
  }

  let ACCESS_TOKEN_VALUE = await JSON.parse(ACCESS_TOKEN);
  return ACCESS_TOKEN_VALUE?.access_token || environment.BACKUP_TOKEN;

  // const ACCESS_TOKEN_VALUE = ACCESS_TOKEN ? JSON.parse(ACCESS_TOKEN) : {};
  // return ACCESS_TOKEN_VALUE.access_token || environment.BACKUP_TOKEN;
};

/* Refactoring new methods */
async function getAuthHeader() {
  return getAccessToken()
    .then(token => `Bearer ${token}`)
    .then(Authorization => {
      return { Authorization };
    });
}

export function getUrlWithQueryParams(url, queryParamsOverrides = {}) {
  const isAbsoluteUrl = url?.startsWith('http');

  let urlObject = new URL(url, 'https://dummy');
  const parametersFromUrl = Object.fromEntries(urlObject.searchParams.entries());

  const { jessionId, userSelectedCityCode, userDefaultCityCode } = getAppConfig();
  const defaultQueryParams = {
    appId: APP_CONSTANTS.APP_ID,
    AppSessionToken: jessionId,
    charset: 'utf-8',
    city: userSelectedCityCode || userDefaultCityCode,
  };

  let mergedQP = {};
  if ('-*' in queryParamsOverrides) {
    delete queryParamsOverrides['-*'];
    mergedQP = Object.assign({}, parametersFromUrl, queryParamsOverrides);
  } else {
    mergedQP = Object.assign({}, defaultQueryParams, parametersFromUrl, queryParamsOverrides);
  }

  let queryString = '';
  const mergedQueryParamObject = new URLSearchParams(mergedQP);
  if (Object.keys(mergedQP).length > 0) {
    queryString = '?' + mergedQueryParamObject.toString();
  }

  let wholeUrl = '';
  if (isAbsoluteUrl) {
    wholeUrl = `${urlObject.origin}`;
  }
  wholeUrl += urlObject.pathname + queryString;

  return wholeUrl;
}

export async function getHeaders(headerOverrides = {}, useAuth = true) {
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  const outputHeaders = Object.assign({}, defaultHeaders, headerOverrides);
  if (useAuth) {
    return getAuthHeader().then(authHeader => Object.assign(outputHeaders, authHeader));
  }
  return outputHeaders;
}
export async function httpGetRaw(url, params = {}, headerOverrides = {}, useAuth = true) {
  const headers = await getHeaders(headerOverrides, useAuth);
  const urlWithParams = getUrlWithQueryParams(url, params);
  const method = 'GET';

  return fetch(urlWithParams, {
    headers,
    method,
  }).then(res => {
    if (res.status === 401) {
      sessionStorage.removeItem('accessToken');
      window.location.reload();
    }
    return res;
  });
}

export async function httpGetJSON(url, params = {}, headerOverrides = {}, useAuth = true) {
  return httpGetRaw(url, params, headerOverrides, useAuth).then(res => res.json());
}

export async function httpPostRaw(url, body, headerOverrides = {}, useAuth = true) {
  const headers = await getHeaders(headerOverrides, useAuth);
  const method = 'POST';

  return fetch(url, {
    headers,
    method,
    body,
  });
}

/* ---------- MULTIPART UPLOAD ---------- */

export async function httpUpload(url, formData) {
  return fetch(url, {
    method: 'POST',
    headers: { CSRFToken: ACC.config.CSRFToken },
    body: formData,
  }).then(res => res.json());
}

export async function httpPostJSON(url, body, headerOverrides = {}, useAuth = true) {
  return httpPostRaw(url, body, headerOverrides, useAuth).then(res => res.json());
}

export async function httpPutRaw(url, body, headerOverrides = {}, useAuth = true) {
  const headers = await getHeaders(headerOverrides, useAuth);
  const method = 'PUT';

  return fetch(url, {
    headers,
    method,
    body,
  });
}
export async function httpPutJSON(url, body, headerOverrides = {}) {
  return httpPutRaw(url, body, headerOverrides).then(res => res.json());
}

// Imported from token-services.js
let tokenServicePromise = null;
const { jessionId } = getAppConfig();

export async function getGuestToken() {
  if (tokenServicePromise === null) {
    tokenServicePromise = new Promise(resolve => {
      const params = {
        client_id: APP_CONSTANTS.CLIENT_ID,
        client_secret: APP_CONSTANTS.CLIENT_SECRET,
        deviceId: jessionId,
        grant_type: 'client_credentials',
      };

      const _url = `${APP_CONSTANTS.APP_BASE_URL}/${APP_CONSTANTS.GET_TOKEN_URL}`;

      const body = new URLSearchParams(params).toString();

      // Authorization Header
      const headers = {
        Authorization: `Basic ${APP_CONSTANTS.CLIENT_SECRET}`,
      };

      httpPostRaw(_url, body, headers, false)
        .then(response => {
          if (response.status === 200) {
            response.json().then(access_token => {
              const EXPIRE_IN = access_token.expires_in || 0;

              const expiryTime = new Date(new Date().getTime() + EXPIRE_IN * 1000);

              sessionStorage.setItem(
                'accessToken',
                JSON.stringify({
                  ...access_token,
                  expiryTime: expiryTime.getTime(),
                })
              );

              resolve(true);
            });
          } else {
            resolve(false);
          }
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  return tokenServicePromise;
}
